module.exports = __webpack_public_path__ + "img/Superb_sword_02.6aa3a028.png";